import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Institution} from "../../../../../models/institution";
import {InstitutionUnit} from "../../../../../models/Institution-unit";
import {Role} from "../../../../../models/role";
import {RoleInstitution} from "../../../../../models/role-institution";
import {InstitutionControllerService} from "../../../../../services/institution-controller/institution-controller.service";
import {RegistrationInstitutionControllerService} from "../../../../../services/institution-controller/institution-registration-controller.service";
import {RoleInstitutionControllerService} from "../../../../../services/role-controller/role-institution-controller.service";
import {RoleUnitControllerService} from "../../../../../services/role-controller/role-unit-controller.service";
import {Store} from "../../../../../services/store.service";
import {RegistrationUnitControllerService} from "../../../../../services/unit-controller/unit-registration-controller.service";
import {UnitService} from "../../../../../services/unit-controller/unit.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "unit-role",
  templateUrl: "./unit-role.component.html",
  providers: [RoleInstitutionControllerService, InstitutionControllerService, RoleUnitControllerService, RegistrationInstitutionControllerService,
    RegistrationUnitControllerService],
  styles: [],
})
export class UnitRoleComponent extends TranslatedBaseError implements OnChanges, OnDestroy {

  public roleId: string;
  @Input() public role: Role;
  @Input() public serviceId: string;
  @Input() public updateList: boolean = false;
  @Input() public roleInstitutions: RoleInstitution[];
  @Output() public roleUnitsLength = new EventEmitter();
  public roleUnits: RoleInstitution[];
  public roleUnitsListLength: number;

  public institutionUnits: InstitutionUnit[] = [];
  public institutionUnit: InstitutionUnit;

  public searchInstitutionUnitFilter: any;
  public firstRequestDone: boolean = false;
  public addNew: boolean = false;
  public showList: boolean = false;
  public showInstitutionUnit = {};

  public subscription: any;

  constructor(private roleUnitControllerService: RoleUnitControllerService,
              private institutionControllerService: InstitutionControllerService,
              private unitService: UnitService,
              public store: Store,
              private route: ActivatedRoute,
              toastr: ToastrService,
              public translateService: TranslateService,
              private roleInstitutionControllerService: RoleInstitutionControllerService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.roleId = params.roleId;
    });
    this.subscription = this.unitService.update.subscribe((data) => {
      if (data.update) {
        this.reloadUnitList();
      }
    });
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    this.route.params.subscribe((params) => {
      this.roleId = params.roleId;
    });
    /*
    if (!this.firstRequestDone || changes.role && changes.role.currentValue && changes.role.previousValue
      && changes.role.currentValue.id !== changes.role.previousValue.id) {
      this.reloadUnitList();
    }
    */
    this.reloadUnitList();
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public reloadUnitList() {
    if (this.role && this.role.id) {
      this.roleUnitControllerService.getRoleUnitList(this.role.id).subscribe(
        (data) => {
          this.firstRequestDone = true;
          this.updateData(data);
        },
      );
    }
  }

  public updateData(data) {
    this.showList = false;
    this.institutionUnits = [];
    this.roleUnitsListLength = data.length;
    this.roleUnitsLength.emit({roleUnitsLength: data.length});
    this.loadUnits();
  }

  public loadUnits() {
    for (const roleInstit of this.roleInstitutions) {
      this.loadInstitutionUnits(roleInstit);
    }
  }

  public loadInstitutionUnits(roleInstitution: RoleInstitution) {
    this.institutionControllerService.getInstitutionChildrenByRoleInstitution(roleInstitution).subscribe(
      (inst) => {
        UnitRoleComponent.addUnits(inst, roleInstitution);
      },
    );
  }

  public getUnit(inst) {
    if (inst && inst.units && inst.units.length && inst.unitId) {
      const unit = inst.units.find((u) => String(u.id) === String(inst.unitId));
      return unit;
    }
  }

  public getUnitName(inst) {
    return this.getUnit(inst) ? this.getUnit(inst).name : "-";
  }

  public getUnitId(inst) {
    return this.getUnit(inst) ? this.getUnit(inst).id : "-";
  }

  public deleteRoleUnit(isConfirmed, inst) {
    if (isConfirmed) {
      if (this.roleId && inst) {
        inst.unitId = null;
        this.roleUnitControllerService.saveRoleUnit(this.roleId, inst).subscribe(
          (createData) => {
            this.responseSuccessful("Unit removed from Role!");
            // this.reloadUnitList();
            // this.updateData();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
        );
      }
    }
  }

  public static addUnits(inst: Institution, roleInstit: RoleInstitution) {
    roleInstit.units = [];
    if (inst.units) {
      for (const unit of inst.units) {
        roleInstit.units.push(unit);
      }
      roleInstit.units.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
      });
      // this.getName(inst);
    }
  }

  public checkAllreadyUsedUnit(instID, unitID) {
    return this.roleInstitutions.find((i) => {
      return String(i.institutionId) === String(instID) && String(i.unitId) === String(unitID);
    });
  }

  public getName(institution) {
    this.showInstitutionUnit = {};
    if (institution.units != null && this.roleUnits != null) {
      for (const entry of institution.units) {
        this.showInstitutionUnit[entry.id] = true;
        for (const roleUnit of this.roleUnits) {
          const unitId = roleUnit.unitId && roleUnit.unitId.toString();
          const entryId = entry.id && entry.id.toString();
          if (unitId === entryId) {
            roleUnit.unitName = entry.name;
            this.showInstitutionUnit[entry.id] = false;
          }
        }
      }
    }
    }

  public addRoleUnit(inst, institutionUnit) {
    if (this.roleId && inst && institutionUnit) {
      inst.unitId = institutionUnit[0].id;
      this.roleUnitControllerService.saveRoleUnit(this.roleId, inst).subscribe(
        (createData) => {
          this.responseSuccessful("Unit added to Role!");
          // this.reloadUnitList();
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }

  public selectRoleUnit(value) {
    let selectedUnit;
    this.institutionUnits.forEach((institutionUnit) => {
      if (institutionUnit.id === value.id) {
        selectedUnit = institutionUnit;
      }
    });
    if (this.roleId) {
      const newRoleUnit: RoleInstitution = new RoleInstitution();
      newRoleUnit.institutionId = selectedUnit.institution_id;
      newRoleUnit.unitId = selectedUnit.id;
      newRoleUnit.roleId = this.roleId;
      this.roleUnitControllerService.saveRoleUnit(this.roleId, newRoleUnit).subscribe(
        (data) => {this.responseSuccessful("Data is saved!"); this.reloadUnitList(); },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }
  public removeRoleUnit(value) {
    this.deleteRoleUnit(true, value.id);
  }

  public openEdit(roleInstitutionUnit: any, inst: RoleInstitution, name?: string) {
    if (roleInstitutionUnit) {
      for (const institutionUnit of inst.units) {
        if (institutionUnit.id === roleInstitutionUnit) {
          this.institutionUnit = institutionUnit;
        }
      }
      this.addNew = false;
    } else {
      this.institutionUnit = new InstitutionUnit();
      this.institutionUnit.name = name || this.searchInstitutionUnitFilter?.name;
      this.institutionUnit.institution_id = inst.institutionId;
      this.addNew = true;
    }
    this.updateEditData(inst);
  }

  public updateEditData(inst: RoleInstitution) {
    this.showList = false;
    this.store.state.common.sections.type = "unit";
    this.unitService.role = this.role;
    this.unitService.institutionUnit = JSON.parse(JSON.stringify(this.institutionUnit)); // mini-hack so the list doesn't update when working in edit layer
    this.unitService.roleInstitution = inst;
    this.unitService.addNew = this.addNew;
    this.unitService.context = "role";
    this.unitService.initEdit();
  }

  public searchInstitutionUnitChanged(value: any): void {
    this.searchInstitutionUnitFilter = { name: value };
  }

}
